import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import LandingAnalyzeFeedbackHelmet from 'common/helmets/LandingAnalyzeFeedbackHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import withContexts from 'common/util/withContexts';
import FeaturesChildPagePagination from 'common/www/FeaturesChildPagePagination';
import Point1 from 'img/landing/analyze-feedback-1.webp';
import Point2 from 'img/landing/analyze-feedback-2.webp';
import Point3 from 'img/landing/analyze-feedback-3.webp';

import 'css/components/www/_LandingFeaturesChildPage.scss';

class LandingAnalyzeFeedbackPage extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Feedback Child Page');
  }

  render() {
    return (
      <div className="landingAnalyzeFeedbackPage landingFeaturesChildPage">
        <LandingAnalyzeFeedbackHelmet />
        <div className="fullWidthContainer">
          <div className="header">
            <div className="text">
              <h1>Analyze your product&nbsp;feedback</h1>
              <p className="subheading">
                Resources are always limited. Identify which features will be most impactful to
                work&nbsp;on.
              </p>
              <Link className="LandingGlobal__cta" to="/register">
                Get Started
              </Link>
            </div>
          </div>
        </div>
        <div className="mainContentContainer">
          <h2>Canny helps you cut through the&nbsp;noise</h2>
          <div className="point">
            <LazyLoadedImage
              loading="eager"
              src={Point1}
              alt="Analyzing feedback by adding relevant data"
            />
            <div className="text">
              <h2 className="title">Analyze feedback by adding relevant&nbsp;data</h2>
              <p>
                Your business is unique. Send data into Canny to better understand where your
                feedback comes&nbsp;from.
              </p>
              <ul>
                <li>
                  Include{' '}
                  <a href="https://developers.canny.io/install/companies">company&nbsp;data</a> like
                  monthly spend and{' '}
                  <a href="https://developers.canny.io/install/custom-fields">custom&nbsp;fields</a>{' '}
                  relevant to your&nbsp;business
                </li>
                <li>Sort posts by MRR&nbsp;impact</li>
                <li>Build segments specifically tailored to your&nbsp;business</li>
              </ul>
            </div>
          </div>
          <div className="point">
            <LazyLoadedImage src={Point2} alt="Filter feedback for better data" />
            <div className="text">
              <h2 className="title">Focus on analyzing feedback from specific&nbsp;customers</h2>
              <p>
                Getting feedback from all of your users is great. However, you may find that the
                feedback from your most valuable customers is being&nbsp;diluted.
              </p>
              <ul>
                <li>
                  Using segments built with custom fields, filter to see feedback from a specific
                  customer&nbsp;segment
                </li>
                <li>Filter popular posts by segment to see where votes are coming&nbsp;from</li>
              </ul>
            </div>
          </div>
          <div className="point">
            <LazyLoadedImage
              src={Point3}
              alt="Analyze feedback better by starting a conversation"
            />
            <div className="text">
              <h2 className="title">Investigate feedback further with low&nbsp;effort</h2>
              <p>
                Canny keeps track of exactly who requested a feature. Use that to start a
                conversation and dig&nbsp;deeper.
              </p>
              <ul>
                <li>
                  Comment on posts to get more insights—clarify the scope of a feature and potential
                  effort&nbsp;required
                </li>
                <li>
                  Use internal comments to take note of additional context from&nbsp;customers
                </li>
              </ul>
            </div>
          </div>
          <FeaturesChildPagePagination currentPage="analyze" />
          <LandingFooterCTA style="solid" expanded={true} />
        </div>
      </div>
    );
  }
}

export default compose(
  withContexts({ trackEvent: TrackEventContext }),
  hot,
)(LandingAnalyzeFeedbackPage);
